import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { endOfApiScale, startOfApiScale } from '@library/store/measures/measures';
import { EnumApiScales, EnumScales, TimeRange } from '@library/store/measures/measures.interface';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-time-range',
  templateUrl: './time-range.component.html',
  styleUrls: ['./time-range.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeRangeComponent implements OnInit {

  @Input() selectedTimeRange: TimeRange;
  @Output() selectedTimeRangeChange = new EventEmitter<TimeRange>();

  @Input() scale: EnumScales;

  @Input() disabled = false;

  EnumScales = EnumScales;

  minDate = moment('2011');

  maxDate = moment();

  constructor() { }

  ngOnInit(): void {
  }

  selectTimeRange(timeRange: TimeRange) {
    this.selectedTimeRangeChange.next(timeRange);
  }

  selectPreviousTimeRange($event: Event) {
    $event.stopPropagation();
    const { dateBegin } = this.selectedTimeRange;

    const timeRange = {
      dateBegin: startOfApiScale(dateBegin.clone().subtract(1, 'day'), this.scaleToApiScale(this.scale)),
      dateEnd: endOfApiScale(dateBegin.clone().subtract(1, 'day'), this.scaleToApiScale(this.scale)),
    };

    if (startOfApiScale(this.minDate.clone(), this.scaleToApiScale(this.scale))  < startOfApiScale(timeRange.dateBegin.clone(),  this.scaleToApiScale(this.scale)))  {
      this.selectTimeRange(timeRange);
    }

  }

  selectNextTimeRange($event: Event) {
    $event.stopPropagation();
    const {dateEnd } = this.selectedTimeRange;

    const timeRange = {
      dateBegin: startOfApiScale(dateEnd.clone().add(1, 'day'), this.scaleToApiScale(this.scale)),
      dateEnd: endOfApiScale(dateEnd.clone().add(1, 'day'), this.scaleToApiScale(this.scale)),
    };

    if (endOfApiScale(timeRange.dateEnd.clone(), this.scaleToApiScale(this.scale)) <= endOfApiScale(this.maxDate.clone(), this.scaleToApiScale(this.scale))) {
      
      this.selectTimeRange(timeRange);
    }
  }

  // #TODO use injection token for this mapping
  public scaleToApiScale(scale: EnumScales) {
    switch (scale) {
      case EnumScales.DAY:
        return EnumApiScales.FIVE_MINUTES;
      case EnumScales.WEEK:
        return EnumApiScales.THREE_HOURS;
      case EnumScales.MONTH_DAILY:
        return EnumApiScales.ONE_DAY;
      case EnumScales.YEAR:
        return EnumApiScales.ONE_WEEK;
    }
  }

  get formattedTimeRange() {
    switch (this.scale) {
      case EnumScales.DAY:
        return this.selectedTimeRange.dateBegin.format('ddd, ll')
      case EnumScales.WEEK:
        const dayStartWeek = this.selectedTimeRange.dateBegin.format('D');
        const dayEndWeek = this.selectedTimeRange.dateEnd.format('D');
        const monthStartWeek = this.selectedTimeRange.dateBegin.format('MMM');
        const monthEndWeek = this.selectedTimeRange.dateEnd.format('MMM');
        const yeardEndWeek = this.selectedTimeRange.dateEnd.format('YYYY');
        return `${dayStartWeek} ${monthStartWeek} - ${dayEndWeek} ${monthEndWeek} ${yeardEndWeek}`
      case EnumScales.MONTH_DAILY:
        return this.selectedTimeRange.dateBegin.format('MMMM YYYY')
      case EnumScales.YEAR:
        return this.selectedTimeRange.dateBegin.clone().endOf('isoWeek').format('YYYY')
      default:
        throw new Error(`Scale: ${this.scale} is not implemented`);
    }
  }


}
